export class AiGeneratedQuestionDto {
  id: number;
  reference: string;
  statement: string;
  answers: string[];
  correctAnswer: number;
  comment: string;
  subjectId: number;
  subjectName: string;
  topicId: number;
  topicName: string;
  difficulty: number;
  // Que evalua la pregunta, en una linea. Es lo que usa el backend para no repetir preguntas,
  // y en la tabla sirve para ver de un vistazo si dos filas preguntan lo mismo.
  keyPoint: string;
  created: string;

  // solo en cliente: para dar feedback inmediato sin recargar la lista entera
  processing: boolean;
  /** Key de S3 de la imagen del enunciado, si la lleva. */
  imageUrl: string;
  /** Id de question_multimedia, para poder retocarla o quitarla desde la revisión. */
  imageId: number;
}
